// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1_s53","cls2":"ZeroState-cls2_3dY ZeroState-cls1_s53"};